module.exports = __webpack_public_path__ + "img/nzl.3241e927.svg";